const version = "v1";

export enum ApplicationApiPaths{
    CREATE_TEMPORARY_APPLICATION,
    UPLOAD_DOCUMENT,
    UPLOAD_LIVENESS,
    GET_SUMMARY,
    GET_STATUS,
    SUBMIT
}

export function getApplicationApiPaths(id:string | undefined,applicationApiPaths: ApplicationApiPaths){
    switch(applicationApiPaths){
        case ApplicationApiPaths.CREATE_TEMPORARY_APPLICATION:
            return `${apiPaths.idv}/application`
        case ApplicationApiPaths.UPLOAD_DOCUMENT:
            return `${apiPaths.idv}/application/${id}/documents`
        case ApplicationApiPaths.UPLOAD_LIVENESS:
            return `${apiPaths.idv}/application/${id}/liveness`
        case ApplicationApiPaths.GET_SUMMARY:
            return `${apiPaths.idv}/application/${id}/summary`
        case ApplicationApiPaths.GET_STATUS:
            return `${apiPaths.reviewcenter}/application/${id}/status`
        case ApplicationApiPaths.SUBMIT:
            return `${apiPaths.reviewcenter}/application`
        }
}

export const apiPaths = {
    // Anonymous client session; there is no identity provider to redirect to.
    session: `/api/${version}/session`,
    sessionEnd: `/api/${version}/session/end`,
    clientLookup: `/api/${version}/client/lookup`,
    clientApplicant: `/api/${version}/client/applicant`,
    idv: `/api/${version}/idv`,
    reviewcenter: `/api/${version}/reviewcenter`,
    sessionTimeout: `/api/${version}/session-timeout`,
    keepAlive: `/api/${version}/keep-alive`
}
